import { useState } from "react"
import { CVFile } from "../interface/CV_types"
import { OrangeButton } from "@/components/Buttons"
import { DownloadIcon } from "lucide-react"
import { download_file } from "../api/cloud_viewer"
import { downloadFileFromResponse } from "@/components/Projects/Table/api/download_documents"

export function DownloadButton({file, project_id}: {file: CVFile, project_id: string}) {
    const [isDownloading, setIsDownloading] = useState(false)

    const handleDownload = async () => {
        setIsDownloading(true)

        // Download the file
        const response = await download_file(project_id, file.name)
        if (response.status === 200) {
            downloadFileFromResponse(response)
        } else {
            alert("Error downloading file")
        }

        setIsDownloading(false)
    }

    return (
        <OrangeButton onClick={handleDownload} disabled={isDownloading}>
            {isDownloading ? "Downloading..." : <DownloadIcon className="w-4 h-4" />}
        </OrangeButton>
    )
}